import { memo } from 'react'
import { useTranslation } from 'react-i18next'
import { trackSpotModeEntityTypeChanged } from '../../utils/analytics'
import { labelClasses, getSelectClasses } from '../../styles/inputStyles'

/**
 * EntityTypeSelector - Dropdown for selecting entity/vendor type
 * Used when creating new entities in spot mode
 * 
 * @component
 * @example
 * <EntityTypeSelector
 *   value="food_truck"
 *   onChange={(type) => setSpotModeEntityType(type)}
 *   disabled={false}
 * />
 */
const EntityTypeSelector = memo(function EntityTypeSelector({
  value = 'food_truck',
  onChange,
  disabled = false,
  label,
  required = true
}) {
  const { t } = useTranslation()
  
  const handleChange = (e) => {
    const newType = e.target.value
    const oldType = value
    
    // Track entity type change
    if (newType !== oldType) {
      trackSpotModeEntityTypeChanged(oldType, newType)
    }
    
    onChange(newType)
  }

  return (
    <div className="mb-4">
      <label className={labelClasses}>
        {label || t('map.vendorType.label')} {required && '*'}
      </label>
      <select
        value={value}
        onChange={handleChange}
        disabled={disabled}
        className={getSelectClasses()}
      >
        <option value="food_truck">{t('map.vendorType.food_truck')}</option>
        <option value="restaurant">{t('map.vendorType.restaurant')}</option>
        <option value="pop_up">{t('map.vendorType.pop_up')}</option>
        <option value="market">{t('map.vendorType.market')}</option>
        <option value="delivery">{t('map.vendorType.delivery')}</option>
        <option value="catering">{t('map.vendorType.catering')}</option>
        <option value="other">{t('map.vendorType.other')}</option>
      </select>
    </div>
  )
})

export default EntityTypeSelector
